<template>
  <el-dialog title="Preview" :visible.sync="visible" width="1020px" top="3vh" custom-class="preview-dialog">
    <div class="pb20 preview-wrapper">
      <iframe v-if="visible && id" :src="iframeSrc" frameborder="0" class="preview-iframe" ref="previewIframe"></iframe>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "Preview",
  data() {
    return {
      visible: false,
      id: "",
    };
  },
  computed: {
    iframeSrc() {
      return `${process.env.VUE_APP_URL_INVOICE}/invoice?previewId=${this.id}`;
    },
  },
  methods: {
    init(id) {
      this.id = id || "";
      this.visible = true;
    },
  },
};
</script>

<style scoped>
.preview-wrapper {
  width: 100%;
  height: 82vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.preview-iframe {
  width: 100%;
  min-height: 100%;
  display: block;
}
</style>
